/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function LeaveIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "leave", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M16.5 15V19.5H5.5V5.5H16.5V10", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10 12.5H22M20 10L22.5 12.5L20 15", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(LeaveIcon);
export default ForwardRef;
//# sourceMappingURL=leaveIcon.js.map